import { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationToolStatus from '../../../types/status'
import CreationToolUploadField from '../../../types/upload-field'
import CreationToolUserRestriction from '../../../types/user-restriction'
import { GridBlock } from '../../blocks'
import { CreationToolUploadContext } from '../manager'
import Collections from './collections'
import CtaText from './cta-text'
import Description from './description'
import Privacy from './privacy'
import Rating from './rating'
import SourceUrl from './source-url'
import SuggestedTags from './suggested-tags'
import Tags from './tags'
import Username from './username'

const Container = styled(GridBlock as any)`
    gap: 30px;
    margin: 30px 0 50px;
`

const CreationUploadFields = () => {
    const { userRestrictionAccess, outputType } = useContext(CreationToolsContext)
    const { status } = useContext(CreationToolUploadContext)

    // filter out any fields that the user doesn't have access to.
    const fields = CreationToolUploadField.all().filter((field) => {
        const userRestriction = CreationToolUploadField.userRestriction(field)
        const hasAccess = CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
        const outputTypeRestrictions = CreationToolUploadField.ouputTypeRestrictions(field)
        return hasAccess && outputTypeRestrictions.indexOf(outputType) > -1
    })

    // map upload fields to components
    const fieldComponents = fields.map((field) => {
        switch (field) {
            case CreationToolUploadField.SourceUrl:
                return SourceUrl
            case CreationToolUploadField.Tags:
                return Tags
            case CreationToolUploadField.Privacy:
                return Privacy
            case CreationToolUploadField.SuggestedTags:
                return SuggestedTags
            case CreationToolUploadField.Rating:
            case CreationToolUploadField.VideoRating:
                return Rating
            case CreationToolUploadField.Username:
                return Username
            case CreationToolUploadField.Collections:
                return Collections
            case CreationToolUploadField.CtaText:
                return CtaText
            case CreationToolUploadField.VideoDescription:
                return Description
        }
    })

    return (
        <Container
            columns={4}
            style={status !== CreationToolStatus.Idle ? { opacity: 0.5, pointerEvents: 'none' } : {}}
        >
            {fieldComponents.map((Field, i) => (Field ? <Field key={fields[i]} field={fields[i]} /> : null))}
        </Container>
    )
}

export default CreationUploadFields
